import { useSnackbar } from "notistack";

import { useState } from "react";
import { Link as RouterLink, useNavigate } from "react-router-dom";
// @mui
import { alpha } from "@mui/material/styles";
import { Box, Divider, Typography, Stack, MenuItem, Dialog, DialogTitle, DialogContent } from "@mui/material";
// routes
import { PATH_DASHBOARD, PATH_AUTH } from "src/routes/paths";
// hooks
import useAuth from "src/hooks/useAuth";
import useIsMountedRef from "src/hooks/useIsMountedRef";
// components
import MyAvatar from "src/components/MyAvatar";
import MenuPopover from "src/components/MenuPopover";
import { IconButtonAnimate } from "src/components/animate";
import useLocales from "src/hooks/useLocales";
import { FUNCTIONS } from "src/contexts/FirebaseContext";
import { httpsCallable } from "firebase/functions";
import LoadingScreen from "src/components/LoadingScreen";
import StripeDashboard from "src/stripe/StripeDashboard";

// ----------------------------------------------------------------------

const MENU_OPTIONS = [
  {
    label: "Home",
    linkTo: "/",
  },

  // {
  //   label: "Settings",
  //   linkTo: PATH_DASHBOARD.user.account,
  // },
];

// ----------------------------------------------------------------------

export default function AccountPopover() {
  const navigate = useNavigate();
  const { translate } = useLocales();
  const { user, logout, currentSubscription } = useAuth();
  const [loading, setLoading] = useState(false);
  const isMountedRef = useIsMountedRef();

  // const StripeDashboard = async () => {
  //   const functionRef = httpsCallable(FUNCTIONS, "ext-firestore-stripe-payments-createPortalLink");
  //   const { data } = await functionRef({
  //     returnUrl: window.location.origin,
  //     // locale: "auto", // Optional, defaults to "auto"
  //     // configuration: "bpc_1JSEAKHYgolSBA358VNoc2Hs", // Optional ID of a portal configuration: https://stripe.com/docs/api/customer_portal/configuration
  //   });
  //   window.location.assign(data.url);
  // };
  const { enqueueSnackbar } = useSnackbar();

  const [open, setOpen] = useState(null);

  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(null);
  };

  const handleLogout = async () => {
    try {
      await logout();
      navigate(PATH_AUTH.login, { replace: true });

      if (isMountedRef.current) {
        handleClose();
      }
    } catch (error) {
      console.error(error);
      enqueueSnackbar("Unable to logout!", { variant: "error" });
    }
  };

  return (
    <>
      <IconButtonAnimate
        onClick={handleOpen}
        sx={{
          p: 0,
          ...(open && {
            "&:before": {
              zIndex: 1,
              content: "''",
              width: "100%",
              height: "100%",
              borderRadius: "50%",
              position: "absolute",
              bgcolor: (theme) => alpha(theme.palette.grey[900], 0.8),
            },
          }),
        }}
      >
        <MyAvatar />
      </IconButtonAnimate>

      <MenuPopover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        sx={{
          p: 0,
          mt: 1.5,
          ml: 0.75,
          "& .MuiMenuItem-root": {
            typography: "body2",
            borderRadius: 0.75,
          },
        }}
      >
        <Box sx={{ my: 1.5, px: 2.5 }}>
          <Typography variant="subtitle2" noWrap>
            {user?.displayName}
          </Typography>
          <Typography variant="body2" sx={{ color: "text.secondary" }} noWrap>
            {user?.email}
          </Typography>
        </Box>

        <Divider sx={{ borderStyle: "dashed" }} />

        <Stack sx={{ p: 1 }}>
          {MENU_OPTIONS.map((option) => (
            <MenuItem key={option.label} to={option.linkTo} component={RouterLink} onClick={handleClose}>
              {translate(option.label)}
            </MenuItem>
          ))}
        </Stack>

        <Divider sx={{ borderStyle: "dashed" }} />
        <Stack sx={{ p: 1 }}>
          <MenuItem
            onClick={
              currentSubscription === ""
                ? () => navigate("/dashboard/user/subscription")
                : () => {
                    setLoading(true);
                    StripeDashboard();
                  }
            }
          >
            {translate("Subscription")}
          </MenuItem>
        </Stack>
        <Divider sx={{ borderStyle: "dashed" }} />

        <MenuItem onClick={handleLogout} sx={{ m: 1 }}>
          {translate("Logout")}
        </MenuItem>
      </MenuPopover>
      <Dialog open={loading}>
        <DialogContent sx={{ p: 3 }}>You will be redirected to Stripe's dashboard</DialogContent>
      </Dialog>
    </>
  );
}
